import Snappy from '../../../libs/snappy/snappy';
import $ from 'jquery';
import queryString from 'query-string';

Snappy.Component.CourseTable = class CourseTable extends Snappy.BaseComponent {
    static get tagName() {
        return 'cfa-course-table';
    }

    constructor(element) {
        super(element);
    }

    render() {
        this.setVars();
        this.setEventListeners();
        this.onPopState();
    }

    setVars() {
        this.$filterDropdown = this.$element.find('.js-cfa-course-table-filter');
        this.$resetButton = this.$element.find('.js-cfa-course-table-reset');
        this.$courseBlocks = this.$element.find('[data-block]');
        this.selectedValue = '';
    }

    setEventListeners() {
        this.bindEventListeners();
        this.$window.on('popstate', this.onPopState.bind(this));
    }

    bindEventListeners() {
        this.unbindEventListeners();
        this.$filterDropdown.on('change', this.bindedFilterDropdownListeners = this.onChange.bind(this));
        this.$resetButton.on('click', this.bindedResetButtonListeners = this.onReset.bind(this));
    }

    unbindEventListeners() {
        this.$filterDropdown.off('change', this.bindedFilterDropdownListeners);
        this.$resetButton.off('click', this.bindedResetButtonListeners);
    }

    onChange(e){
        this.selectedValue = $(e.target).val();
        let filteredBlocks = this.$courseBlocks
            .removeClass('is-hidden')
            .filter((index, el) => {
                return this.selectedValue && $(el).data('block') !== this.selectedValue;
            })
            .addClass('is-hidden');

        this.updateURLHash(this.selectedValue);
    }

    onReset(e){
        e.preventDefault();
        this.$filterDropdown.val('').trigger('change');
    }

    updateURLHash(value) {
        let parsedSearchString = queryString.parse(location.search);
        parsedSearchString['block'] = value;

        const convertedQuery = queryString.stringify(parsedSearchString),
            URL = value !== '' ? location.pathname + '?' + convertedQuery + location.hash : location.pathname + location.hash;

        if ('pushState' in history) {
            history.pushState({}, document.title, URL);
        }
    }

    onPopState() {
        let parsedSearchString = queryString.parse(location.search);

        this.selectedValue = parsedSearchString['block'];

        if (this.selectedValue !== '') {
            this.$filterDropdown.val(this.selectedValue).trigger('change');
        }

    }
};



// WEBPACK FOOTER //
// ./components/course-table/scripts/cfa-course-table.js